// extracted by mini-css-extract-plugin
export default {"content":"CaseDocumentSearchPage_content__CeOhq","back":"CaseDocumentSearchPage_back__N0Tmt"};